import {
  CatSegmentedControl,
  CatSegmentedControlItem
} from 'components/blocks-components';
import { MeasureUnitSelector } from '../types';

const MeasureUnitSelectorBody = ({
  activeIndex,
  onChangeUom,
  uomData
}: MeasureUnitSelector) => {
  return (
    <CatSegmentedControl
      activeIndex={activeIndex}
      data-testid="measure-unit-selector"
    >
      {uomData.map(({ unit, translation, testId }) => (
        <CatSegmentedControlItem
          key={unit}
          data-testid={testId}
          onClick={() => onChangeUom(unit)}
        >
          {translation}
        </CatSegmentedControlItem>
      ))}
    </CatSegmentedControl>
  );
};

export default MeasureUnitSelectorBody;
